
import { Button } from '@/components/ui/button';
import { LogIn, UserPlus, LogOut, User } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useLanguage } from '@/context/LanguageContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export const AuthButtons = () => {
  const { user, signOut, isClient, isTherapist, isAdmin } = useAuth();
  const { t, getLocalizedPath } = useLanguage();

  if (user) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="hidden md:flex">
            <User className="h-4 w-4 mr-2" />
            {t('myAccount')}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {isClient && (
            <DropdownMenuItem asChild>
              <Link to="/client-portal">{t('clientPortal')}</Link>
            </DropdownMenuItem>
          )}
          {isTherapist && (
            <DropdownMenuItem asChild>
              <Link to="/therapist-portal">{t('therapistPortal')}</Link>
            </DropdownMenuItem>
          )}
          {isAdmin && (
            <DropdownMenuItem asChild>
              <Link to="/admin/dashboard">{t('adminPanel')}</Link>
            </DropdownMenuItem>
          )}
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={signOut}>
            <LogOut className="h-4 w-4 mr-2" />
            {t('signOut')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <div className="hidden md:flex items-center space-x-2">
      {/* Login Dropdown */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm">
            <LogIn className="h-4 w-4 mr-2" />
            {t('login')}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem asChild>
            <Link to={getLocalizedPath('/client-login')}>
              <User className="h-4 w-4 mr-2" />
              Como Cliente
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to={getLocalizedPath('/therapist-login')}>
              <User className="h-4 w-4 mr-2" />
              Como Terapeuta
            </Link>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      
      {/* Signup Dropdown */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button size="sm">
            <UserPlus className="h-4 w-4 mr-2" />
            {t('signup')}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem asChild>
            <Link to={getLocalizedPath('/client-signup')}>
              <UserPlus className="h-4 w-4 mr-2" />
              Registrarme como Cliente
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to={getLocalizedPath('/therapist-signup')}>
              <UserPlus className="h-4 w-4 mr-2" />
              Registrarme como Terapeuta
            </Link>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
